/* eslint-disable no-case-declarations */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {isNaN} from 'lodash';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Put, Get} from '@/api/request';
import RevertIcon from '@/assets/icons/Revert.svg';
import Button from '@/components/button/Button';
import * as APPDATA from '@/constants/pcConstAppData';

import BottomMenu from '../../menu/bottommenu/BottomMenu';

import {MEMBRANE_CUT_OFF_LABEL, MEMBRANE_CUT_OFF} from './volumeThresholdSettingConstant';

import './VolumeThresholdSetting.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  topButtonProperties: store.setupStore.topButtonProperties,
}))
class VolumeThresholdSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDefaultValue: false,
      isButtonBackPopUp: false,
      isPressureValueNotChange: true,
      VolumeThreshold: {
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
      },
      newVolumeThreshold: {
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
      },
      defaultVolumeThreshold: {
        [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '20',
        [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '15',
        [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '10',
        [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '7',
        [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '3',
        [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '0',
      },
    };
    this.onClick = this.onClick.bind(this);
    this.onClickReset = this.onClickReset.bind(this);
    this.onChange = this.onChange.bind(this);
    this.successGetDefaultVolumeThresholdSettings = this.successGetDefaultVolumeThresholdSettings.bind(this);
    this.successGetVolumeThresholdSettings = this.successGetVolumeThresholdSettings.bind(this);
    this.sucessPostPressureConfig = this.sucessPostPressureConfig.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.VOLUME_THRESHOLD_SETTING));
    this.setTopMenuProperties(true);
    this.getInitialValue();
  }

  componentWillUnmount() {}

  // eslint-disable-next-line react/sort-comp
  setTopMenuProperties = (disableMainButton) => {
    const topButtonProperties = {
      id: APPDATA.SAVE,
      label: APPDATA.SAVE,
      onClick: this.onClickTopMenu,
      disabled: disableMainButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backAction,
    };
    const titleMenuProperties = APPDATA.SYSTEM_SETTING;
    this.setupTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  setupTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  getInitialValue = () => {
    const param = {};
    const passingValue = {};
    Get(
      APPDATA.API.GET_FACTORY_DEFAULT_VOLUME_THRESHOLD,
      param,
      this.successGetDefaultVolumeThresholdSettings,
      passingValue,
    );
    Get(APPDATA.API.GET_VOLUME_THRESHOLD_SETTINGS, param, this.successGetVolumeThresholdSettings, passingValue);
  };

  successGetDefaultVolumeThresholdSettings = (response) => {
    // ConsoleLog("Response Get Factory Default VolumeThreshold Settings", response);
    const tempVolumeThreshold = {
      [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
    };
    response.data.forEach((value) => {
      switch (value[APPDATA.KEY.MembraneCutOffSize]) {
        case MEMBRANE_CUT_OFF.CHIP_5_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_10_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_30_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_50_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_100_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_300_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        default:
          break;
      }
      // ConsoleLog("forEach tempVolumeThreshold", {tempVolumeThreshold, value});
    });

    // ConsoleLog("successGetDefaultVolumeThresholdSettings tempVolumeThreshold", tempVolumeThreshold);
    this.setState({
      defaultVolumeThreshold: {...tempVolumeThreshold},
    });
  };

  successGetVolumeThresholdSettings = (response) => {
    // ConsoleLog("Response Get Pressure Settings", response);
    const tempVolumeThreshold = {
      [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '',
      [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '',
    };
    response.data.forEach((value) => {
      switch (value[APPDATA.KEY.MembraneCutOffSize]) {
        case MEMBRANE_CUT_OFF.CHIP_5_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_10_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_30_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_50_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_100_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        case MEMBRANE_CUT_OFF.CHIP_300_KDA:
          tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.VolumeChangeThreshold];
          break;
        default:
          break;
      }
    });
    // ConsoleLog("successGetVolumeThresholdSettings tempVolumeThreshold", tempVolumeThreshold);
    this.setState(
      {
        VolumeThreshold: {...tempVolumeThreshold},
        newVolumeThreshold: {...tempVolumeThreshold},
      },
      () => this.checkValueChange(),
    );
  };

  backAction = () => {
    // const {newVolumeThreshold, VolumeThreshold, defaultVolumeThreshold} = this.state;
    if (this.state.isButtonBackPopUp === false) {
      this.goToHomeScreen();
      // let popUpButton = [
      // 	{
      // 		id: APPDATA.YES,
      // 		isPrimaryButton: true,
      // 		onClick: this.onClickPopUpBackButton,
      // 		label: APPDATA.YES,
      // 	},
      // 	{
      // 		id: APPDATA.NO,
      // 		isPrimaryButton: false,
      // 		onClick: this.onClickPopUpBackButton,
      // 		label: APPDATA.NO,
      // 	},
      // ];
      // this.props.dispatch(
      // 	modalActions.showPopUp({
      // 		popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.EXIT_PAGE.TITLE,
      // 		popUpText: (
      // 			<div>
      // 				{APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.EXIT_PAGE.TEXT}
      // 				<br />
      // 				{APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.EXIT_PAGE.QUESTION}
      // 			</div>
      // 		),
      // 		popUpQuestion: undefined,
      // 		popUpButton: popUpButton,
      // 	})
      // );
    } else {
      const popUpButton = [
        {
          id: APPDATA.SAVE,
          label: APPDATA.SAVE,
          isPrimaryButton: true,
          onClick: this.onClickModalButton,
          disabled: false,
        },
        {
          id: APPDATA.DISCARD,
          label: APPDATA.DISCARD,
          isPrimaryButton: false,
          onClick: this.onClickModalButton,
        },
      ];
      this.props.dispatch(
        modalActions.showPopUp({
          popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.SAVE.TITLE,
          popUpText: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.SAVE.TEXT,
          popUpButton,
        }),
      );
    }
  };

  //   onClickPopUpBackButton = (e) => {
  //     this.props.dispatch(modalActions.hidePopUp());
  //     switch (e.currentTarget.id) {
  //       case APPDATA.YES:
  //         this.goToHomeScreen();
  //         break;
  //       case APPDATA.NO:
  //         break;
  //       default:
  //         break;
  //     }
  //   };

  onClickTopMenu = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.SAVE: {
        const popUpButton = [
          {
            id: APPDATA.SAVE,
            label: APPDATA.SAVE,
            isPrimaryButton: true,
            onClick: this.onClickModalButton,
            disabled: false,
          },
          {
            id: APPDATA.DISCARD,
            label: APPDATA.DISCARD,
            isPrimaryButton: false,
            onClick: this.onClickModalButton,
          },
        ];
        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.SAVE.TITLE,
            popUpText: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.SAVE.TEXT,
            popUpButton,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  //   onClickUnSaveSetting = (e) => {
  //     switch (e.currentTarget.id) {
  //       case APPDATA.YES:
  //         // SAVE
  //         this.saveConfig({SaveVolumeThresholdSetting: true});
  //         break;
  //       case APPDATA.NO:
  //         break;
  //       default:
  //         break;
  //     }
  //     this.props.dispatch(modalActions.hidePopUp());
  //     this.goToHomeScreen();
  //   };

  // eslint-disable-next-line class-methods-use-this
  goToHomeScreen = () => {
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  saveConfig = (nextProps) => {
    const {isPressureValueNotChange} = this.state;
    if (nextProps.SaveVolumeThresholdSetting) {
      if (!isPressureValueNotChange) this.postPressureConfig();
      this.setTopMenuProperties(true);
      this.setState({
        isButtonBackPopUp: false,
      });
    }
  };

  postPressureConfig = () => {
    const {newVolumeThreshold} = this.state;
    const param = [
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_5_KDA,
        [APPDATA.KEY.VolumeChangeThreshold]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_10_KDA,
        [APPDATA.KEY.VolumeChangeThreshold]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_30_KDA,
        [APPDATA.KEY.VolumeChangeThreshold]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_50_KDA,
        [APPDATA.KEY.VolumeChangeThreshold]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_100_KDA,
        [APPDATA.KEY.VolumeChangeThreshold]: '',
      },
      {
        [APPDATA.KEY.MembraneCutOffSize]: MEMBRANE_CUT_OFF.CHIP_300_KDA,
        [APPDATA.KEY.VolumeChangeThreshold]: '',
      },
    ];
    let i = 0;
    param.forEach((value) => {
      switch (value[APPDATA.KEY.MembraneCutOffSize]) {
        case MEMBRANE_CUT_OFF.CHIP_5_KDA:
          param[i][APPDATA.KEY.VolumeChangeThreshold] = newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_10_KDA:
          param[i][APPDATA.KEY.VolumeChangeThreshold] = newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_30_KDA:
          param[i][APPDATA.KEY.VolumeChangeThreshold] = newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_50_KDA:
          param[i][APPDATA.KEY.VolumeChangeThreshold] = newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_100_KDA:
          param[i][APPDATA.KEY.VolumeChangeThreshold] = newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA];
          break;
        case MEMBRANE_CUT_OFF.CHIP_300_KDA:
          param[i][APPDATA.KEY.VolumeChangeThreshold] = newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA];
          break;
        default:
          break;
      }
      i++;
    });
    const passingValue = {};
    Put(APPDATA.API.PUT_VOLUME_THRESHOLD_SETTINGS, param, this.sucessPostPressureConfig, passingValue);
  };

  sucessPostPressureConfig = (response) => {
    const {newVolumeThreshold} = this.state;
    // ConsoleLog("response", response);
    if (response.data.message.includes('Failed')) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: response.data.message,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        }),
      );
    } else {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.SAVE.SUCCESS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      const tempVolumeThreshold = {...newVolumeThreshold};
      this.setState(
        {
          VolumeThreshold: tempVolumeThreshold,
        },
        () => this.checkValueChange(),
      );
    }
  };

  checkValueChange() {
    const {newVolumeThreshold, VolumeThreshold, defaultVolumeThreshold} = this.state;
    // ConsoleLog("newVolumeThreshold", newVolumeThreshold);
    // ConsoleLog("VolumeThreshold", VolumeThreshold);
    // ConsoleLog("defaultVolumeThreshold", defaultVolumeThreshold);
    if (JSON.stringify(newVolumeThreshold) === JSON.stringify(defaultVolumeThreshold)) {
      this.setState({
        isDefaultValue: true,
      });
    } else {
      this.setState({
        isDefaultValue: false,
      });
    }
    // ConsoleLog(isDefaultValue)
    if (JSON.stringify(VolumeThreshold) === JSON.stringify(newVolumeThreshold)) {
      this.setState({
        isButtonBackPopUp: false,
        isPressureValueNotChange: true,
      });
      this.setTopMenuProperties(true);
    } else {
      this.setState({
        isButtonBackPopUp: true,
        isPressureValueNotChange: false,
      });
      this.setTopMenuProperties(false);
    }
  }

  onChange(e) {
    const {newVolumeThreshold} = this.state;

    const tempVolumeThreshold = newVolumeThreshold;

    switch (e.type) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA] = e.value;
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA] = e.value;
        break;
      default:
        break;
    }
    this.setState(
      {
        newVolumeThreshold: {...tempVolumeThreshold},
      },
      () => this.checkValueChange(),
    );
  }

  onClick(e) {
    const props = {
      maxDigitAfterDecimal: APPDATA.CONFIGURATION.THRESHOLD_SETTINGS.DECIMAL_PLACE_ACCURACY,
      incrementValue: APPDATA.CONFIGURATION.THRESHOLD_SETTINGS.INC_VALUE,
      currentValue: 0,
      headerTitle: APPDATA.VOLUME_THRESHOLD_SETTING,
      minValue: APPDATA.CONFIGURATION.THRESHOLD_SETTINGS.MIN_VALUE,
      maxValue: APPDATA.CONFIGURATION.THRESHOLD_SETTINGS.MAX_VALUE,
      callback: this.onChange,
      unit: APPDATA.UNIT.mL_per_min,
      validatorInput: undefined,
    };
    switch (e.currentTarget.id) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        // props.minValue = 0
        // props.maxValue = 100
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        props.currentValue = e.currentTarget.value;
        props.headerTitle = e.currentTarget.id;
        props.minValue = 0;
        // props.maxValue = 100
        break;
      default:
        break;
    }
    this.showNumpad(props);
  }

  onClickReset(e) {
    const {newVolumeThreshold, defaultVolumeThreshold} = this.state;

    const tempVolumeThreshold = newVolumeThreshold;
    switch (e.currentTarget.id) {
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA] = defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA] = defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA] = defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA] = defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA] = defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA];
        break;
      case MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]:
        tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA] = defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA];
        break;
      default:
        break;
    }
    this.setState(
      {
        newVolumeThreshold: {...tempVolumeThreshold},
      },
      () => {
        this.checkValueChange();
        // this.postPressureConfig();
      },
    );
  }

  onClickResetDefault = () => {
    // ConsoleLog("Restore button clicked");

    const popUpButton = [
      {
        id: APPDATA.APPLY,
        label: APPDATA.RESTORE.toUpperCase(),
        isPrimaryButton: true,
        onClick: this.onClickModalButton,
        disabled: false,
      },
      {
        id: APPDATA.CANCEL,
        label: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickModalButton,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.RESET_DEFAULT.TITLE,
        popUpText: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.RESET_DEFAULT.TEXT,
        popUpButton,
      }),
    );
  };

  onClickModalButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.APPLY:
        const {defaultVolumeThreshold} = this.state;

        this.setState(
          {
            VolumeThreshold: {...defaultVolumeThreshold},
            newVolumeThreshold: {...defaultVolumeThreshold},
          },
          () => {
            this.checkValueChange();
            this.postPressureConfig();
          },
        );
        break;

      case APPDATA.CANCEL:
        break;
      case APPDATA.SAVE:
        this.saveConfig({SaveVolumeThresholdSetting: true});
        break;
      case APPDATA.DISCARD:
        // this.props.dispatch(
        // 	setupActions.showAlert({
        // 		alertShow: true,
        // 		alertText: APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.SAVE.DISCARD,
        // 		alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        // 	})
        // );
        this.goToHomeScreen();
        break;
      default:
        break;
    }
    this.props.dispatch(modalActions.hidePopUp());
  };

  // successGetFactoryVolumeThresholdSettings = ( response) => {
  //     // ConsoleLog("Response Get Pressure Settings", response);
  //     let tempVolumeThreshold = {
  //         [MEMBRANE_CUT_OFF.CHIP_5_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_10_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_30_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_50_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_100_KDA]: "",
  //         [MEMBRANE_CUT_OFF.CHIP_300_KDA]: "",
  //     }
  //     response.data.forEach((value) => {
  //         switch (value[APPDATA.KEY.MembraneCutOffSize]) {
  //             case MEMBRANE_CUT_OFF.CHIP_5_KDA:
  //                 tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA] = value[APPDATA.KEY.VolumeChangeThreshold]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_10_KDA:
  //                 tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA] = value[APPDATA.KEY.VolumeChangeThreshold]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_30_KDA:
  //                 tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA] = value[APPDATA.KEY.VolumeChangeThreshold]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_50_KDA:
  //                 tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA] = value[APPDATA.KEY.VolumeChangeThreshold]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_100_KDA:
  //                 tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA] = value[APPDATA.KEY.VolumeChangeThreshold]
  //                 break;
  //             case MEMBRANE_CUT_OFF.CHIP_300_KDA:
  //                 tempVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA] = value[APPDATA.KEY.VolumeChangeThreshold]
  //                 break;
  //             default:
  //                 break;
  //         }
  //     });
  //     this.setState({
  //         VolumeThreshold: Object.assign({}, tempVolumeThreshold),
  //         newVolumeThreshold: Object.assign({}, tempVolumeThreshold)
  //     }, () => {
  //         this.checkValueChange()
  //         this.postPressureConfig()
  //     })
  // }
  showNumpad = (props) => {
    this.props.dispatch(
      modalActions.showModal({
        modalHeader: props.headerTitle,
        value: props.currentValue,
        callback: props.callback,
        maxValue: props.maxValue,
        minValue: props.minValue,
        maxDigitAfterDecimal: props.maxDigitAfterDecimal,
        incrementValue: props.incrementValue,
        unit: props.unit,
        validatorInput: props.validatorInput,
      }),
    );
  };

  render() {
    const {isDefaultValue, newVolumeThreshold, defaultVolumeThreshold} = this.state;
    const style = {
      constraint: {
        // fontSize: this.props.fontSize,
        fontSize: this.props.fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : this.props.fontSize,
      },
    };
    return (
      <div style={style.constraint}>
        <div className="row rowHeight middleAlign">
          <div className="col-md-6 divColoredTitle">Volume Change Threshold</div>
          <div className="col-md-6">
            <button
              type="button"
              className="restoreDefaultButton"
              disabled={isDefaultValue}
              onClick={() => this.onClickResetDefault()}
            >
              {APPDATA.FIELD_NAME.RESTORE_ALL_DEFAULT.toUpperCase()}
            </button>
          </div>
        </div>
        <div className="thresholdSettingContent middleAlign">
          <div className="col-md-6">
            <div className="row middleAlign">
              <div className="col-md-5 divTitle">{APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}</div>
              <div className="col-md-6 divTitle">{APPDATA.FIELD_NAME.VOLUME_THRESHOLD}</div>
            </div>
            <div className="thresholdSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]}
                value={newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA]}
                unit={APPDATA.UNIT.mL_per_min}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_5_KDA]}
                onClick={this.onClickReset}
                className={
                  newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA] ===
                  defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_5_KDA]
                    ? 'thresholdResetButton not-visibile-div '
                    : 'thresholdResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="thresholdSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]}
                value={newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA]}
                unit={APPDATA.UNIT.mL_per_min}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_10_KDA]}
                onClick={this.onClickReset}
                className={
                  newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA] ===
                  defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_10_KDA]
                    ? 'thresholdResetButton not-visibile-div '
                    : 'thresholdResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="thresholdSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]}
                value={newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA]}
                unit={APPDATA.UNIT.mL_per_min}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_30_KDA]}
                onClick={this.onClickReset}
                className={
                  newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA] ===
                  defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_30_KDA]
                    ? 'thresholdResetButton not-visibile-div '
                    : 'thresholdResetButton '
                }
                icon={RevertIcon}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="row middleAlign">
              <div className="col-md-5 divTitle">{APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}</div>
              <div className="col-md-6 divTitle">{APPDATA.FIELD_NAME.VOLUME_THRESHOLD}</div>
            </div>
            <div className="thresholdSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]}
                value={newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA]}
                unit={APPDATA.UNIT.mL_per_min}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_50_KDA]}
                onClick={this.onClickReset}
                className={
                  newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA] ===
                  defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_50_KDA]
                    ? 'thresholdResetButton not-visibile-div '
                    : 'thresholdResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="thresholdSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]}
                value={newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA]}
                unit={APPDATA.UNIT.mL_per_min}
                onClick={this.onClick}
                disabled={false}
              />

              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_100_KDA]}
                onClick={this.onClickReset}
                className={
                  newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA] ===
                  defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_100_KDA]
                    ? 'thresholdResetButton not-visibile-div '
                    : 'thresholdResetButton '
                }
                icon={RevertIcon}
              />
            </div>
            <div className="thresholdSettingRowDiv">
              <Input
                label={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]}
                value={newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA]}
                unit={APPDATA.UNIT.mL_per_min}
                onClick={this.onClick}
                disabled={false}
              />
              <Button
                id={MEMBRANE_CUT_OFF_LABEL[MEMBRANE_CUT_OFF.CHIP_300_KDA]}
                onClick={this.onClickReset}
                className={
                  newVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA] ===
                  defaultVolumeThreshold[MEMBRANE_CUT_OFF.CHIP_300_KDA]
                    ? 'thresholdResetButton not-visibile-div '
                    : 'thresholdResetButton '
                }
                icon={RevertIcon}
              />
            </div>
          </div>
        </div>
        <div className="divNotes">
          <span className="notes">{APPDATA.MESSAGES.SYSTEM_SETTING.THRESHOLD_SETTING.NOTES}</span>
        </div>

        <BottomMenu />
      </div>
    );
  }
}
function Input(props) {
  const {label, value, unit, onClick, hideField, fullWidthInput, disabled} = props;
  const valueParse = parseFloat(value);
  const inputValue = isNaN(valueParse) ? value : valueParse; // .toFixed(decimal)
  const classInputCollumn = unit === undefined ? 'div-2col50 divInput center' : 'div-3colInputSettings divInput center';
  const classInputField = fullWidthInput ? 'inputField inputFullWitdh' : 'inputField';
  return (
    <div className={classInputCollumn}>
      {!hideField && (
        <span
          className="spanStyleInputField"
          disabled={disabled}
        >
          {label}
        </span>
      )}
      {!hideField && (
        <input
          className={classInputField}
          id={label}
          value={value === APPDATA.EMPTY_FIELD ? '' : inputValue}
          readOnly
          onClick={onClick}
          disabled={disabled}
        />
      )}
      {unit !== undefined && !hideField && (
        <span
          className="spanStyleInputField"
          disabled={disabled}
        >
          {unit}
        </span>
      )}
    </div>
  );
}

export default VolumeThresholdSetting;
